exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".three-dim-multipal-player[data-v-3cf933a1]  .imosSdk-video{width:100%!important;height:calc(100% - 28px)!important}.forVideo[data-v-3cf933a1]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:start;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-wrap:wrap;flex-wrap:wrap}", ""]);

// exports
